/*
export const datas = {
    'url envoi formulaire'  :   'http://localhost:8888/REACT/11/build/externals/postContactDatas.php',
    'url animation timer'   :   'externals/timer.gif'
}
*/

export const datas = {
    'url envoi formulaire'  :   'https://cie-candide.com/wp-content/themes/cie-candide/scripts/contact/externals/postContactDatas.php',
    'url animation timer'   :   'https://cie-candide.com/wp-content/themes/cie-candide/scripts/contact/externals/timer.gif'
}